import React from 'react'

import { Tab } from '@pnld/components-web'

import Census from './census'
import Comparative from './comparative'
import Panorama from './panorama'
import Prediction from './prediction'

const Panels: React.FC = () => {
  const tabs = [
    {
      title: 'Predição',
      render: () => <Prediction />,
    },
    {
      title: 'Censo',
      render: () => <Census />,
    },
    {
      title: 'Comparativos',
      render: () => <Comparative />,
    },
    {
      title: 'Panorama',
      render: () => <Panorama />,
    },
  ]

  return <Tab panels={tabs} isFitted />
}

export default Panels
